import { AUTHORITY_TYPE, EXTENSION_REQUEST_STATUS, INTEREST_REPAYMENT_TYPE, stringToEnum } from 'enums';

export interface ExtensionRequestDetailVO {
  extensionRequestId: number;
  extensionStartDate: string;
  extendedRepaymentDate: string;
  additionalRate: number;
  extensionReason: string;
  rejectReason: string;
  returnReason: string;
  extensionRequestStatus: string;
  loanId: number;
  financierLoanId: string;
  currencyType: string;
  financierId: number;
  financierName: string;
  dealerClientId: number;
  dealerClientCode: string;
  dealerClientName: string;
  anchorClientId: number;
  anchorClientCode: string;
  anchorClientName: string;
  disbursedDate: string;
  repaidPrincipalAmount: number;
  interestRepaymentType: string;
  preApprovedName: string;
  preApprovedAuthorityType: string;
  preApprovedDepartment: string;
  preApprovedDateTime: string;
  approvedName: string;
  approvedAuthorityType: string;
  approvedDepartment: string;
  approvedDateTime: string;
  createdDateTime: string;
  disbursedBasisInterestRate: number;
  disbursedTotalInterestRateWithoutBasis: number;
}

export interface ExtensionRequestDetailVOModel extends ExtensionRequestDetailVO {
  extensionRequestStatus: EXTENSION_REQUEST_STATUS;
  interestRepaymentType: INTEREST_REPAYMENT_TYPE;
  preApprovedAuthorityType: AUTHORITY_TYPE;
  approvedAuthorityType: AUTHORITY_TYPE;
}

export function formattingToExtensionRequestDetailVOModel(
  data: ExtensionRequestDetailVO,
): ExtensionRequestDetailVOModel {
  return {
    ...data,
    extensionRequestStatus: stringToEnum(EXTENSION_REQUEST_STATUS, data.extensionRequestStatus),
    interestRepaymentType: stringToEnum(INTEREST_REPAYMENT_TYPE, data.interestRepaymentType),
    preApprovedAuthorityType: stringToEnum(AUTHORITY_TYPE, data.preApprovedAuthorityType),
    approvedAuthorityType: stringToEnum(AUTHORITY_TYPE, data.approvedAuthorityType),
  };
}
